import React, { useEffect } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import {
  ContentLayout,
  Header,
  Container,
} from '@cloudscape-design/components';
// import { ServerSideUsageSummaryTable } from '../../../pages/reports/usagesummary/components/server-side-usage-summary-table';
import { COLUMNDEFINITIONS } from '../../../pages/reports/usagesummary/components/usage-summary-column-definitions';
// import MapWithMarkerPopup from '../../../pages/map/map';
// import { Top5 } from '../../../pages/reports/usagesummary/components/topfiveusage';
import Dev1 from '../../../pages/dev/1';
import Dev2 from '../../../pages/dev/2';
import Dev3 from '../../../pages/dev/3';
import DevMsg from '../../../pages/dev/msg';
import DevBryan from '../../../pages/dev/bryan';
import DevCameron from '../../../pages/dev/cameron';
import DevMatty from '../../../pages/dev/matty';
import DemoStyle from '../../../pages/demo/style';
import DemoTable from '../../../pages/demo/table';
import David from '../../../pages/dev/david';
import Venkata from '../../../pages/dev/venkata';
// import DefaultPage from '../../../pages/default';
// import DashboardPage from '../../../pages/dashboard/dashboard';
// import { ContactUs } from '../../../pages/support/contact-us';

// Testing lazy loading to improve loadtimes
import { lazy, Suspense } from "react";
const DashboardPage = lazy(() => import("../../../pages/dashboard/dashboard"));
const DefaultPage = lazy(() => import("../../../pages/default"));
const MapWithMarkerPopup = lazy(() => import("../../../pages/map/map"));
// Since the components are not exported as a default class, we have to specify the default to make React happy
const ServerSideUsageSummaryTable = lazy(() =>
  import(
    "../../../pages/reports/usagesummary/components/server-side-usage-summary-table"
  ).then(({ ServerSideUsageSummaryTable }) => ({
    default: ServerSideUsageSummaryTable,
  }))
);
const Top5 = lazy(() =>
  import("../../../pages/reports/usagesummary/components/topfiveusage").then(
    ({ Top5 }) => ({
      default: Top5,
    })
  )
);
const ContactUs = lazy(() =>
  import("../../../pages/support/contact-us").then(({ ContactUs }) => ({
    default: ContactUs,
  }))
);

interface RoutesComponentProps {
  updateDynamicHelpMessage: (message: string) => void;
  updateSplitPanelFunction: (splitPanelContent: any) => void;
  updateSplitPanelOpen: (open: boolean) => void;
}

const RoutesComponent: React.FC<RoutesComponentProps> = ({
  updateDynamicHelpMessage,
  updateSplitPanelFunction,
  updateSplitPanelOpen,
}) => {
  const location = useLocation();

  const getHelpMessage = () => {
    switch (location.pathname) {
      case '/reports/terminal-usage':
        return 'Usage data is displayed with the month-to-date usage for the current month. Please be aware that usage data can take 2 days to populate and is recorded in the UTC timezone.';
      case '/reports/top-five-usage':
        return 'Top five Usage data is displayed with the month-to-date usage for the current month. Please be aware that usage data can take 2 days to populate and is recorded in the UTC timezone.';
      case '/map':
        return 'For questions about your network, please call the X2nSat Network Operations Center at (707) 664-5119.';
      default:
        return 'Please call the X2nSat Network Operations Center at (707) 664-5119 with questions.';
    }
  };

  const updateSplitPanelOpenFunction = () => {
    switch (location.pathname) {
      case '/reports/terminal-usage':
        return;
      case '/map':
        updateSplitPanelOpen(false);
        updateSplitPanelFunction(<></>);
        return;
      default:
        updateSplitPanelOpen(false);
        updateSplitPanelFunction(<></>);
        return;
    }
  };

  useEffect(() => {
    const dynamicMessage = getHelpMessage();
    updateDynamicHelpMessage(dynamicMessage);
    updateSplitPanelOpenFunction();
  }, [location.pathname]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path='/' element={<Navigate to='/dashboard' />} />
        <Route
          path='/reports/terminal-usage'
          element={
            <div style={{ width: '100%' }} className='container'>
              <ServerSideUsageSummaryTable
                updateSplitPanelOpen={updateSplitPanelOpen}
                updateSplitPanel={updateSplitPanelFunction}
                columnDefinitions={COLUMNDEFINITIONS}
              />
            </div>
          }
        />
        <Route path='/reports/top-five-usage' element={<Top5 />} />
        {/* <Route path='/dev/dashboard' element={<Dashboard updateSplitPanelOpen={updateSplitPanelOpen} updateSplitPanel={updateSplitPanelFunction}/>} /> */}
        <Route path='/dev/1' element={<Dev1 />} />
        <Route path='/dev/2' element={<Dev2 />} />
        <Route path='/dev/3' element={<Dev3 />} />
        <Route path='/dev/msg' element={<DevMsg />} />
        <Route path='/dev/bryan' element={<DevBryan />} />
        <Route path='/dev/cameron' element={<DevCameron />} />
        <Route path='/dev/matty' element={<DevMatty />} />
        <Route path='/dev/david' element={<David />} />
        <Route path='/dev/venkata' element={<Venkata />} />
        <Route path='/demo/style' element={<DemoStyle />} />
        <Route path='/demo/table' element={<DemoTable />} />
        {/* <Route path='/support' element={<ContactUs />} /> */}
        {/* Use support/contact-us instead of just /support when more support pages defined */}
        {/* <Route path='/support/contact-us' element={<ContactUs />} /> */}
        <Route path='/support' element={<ContactUs />} />
        <Route
          path='/help'
          element={
            <ContentLayout header={<Header variant='h1'>Help</Header>}>
              <Container>
                <div>{getHelpMessage()}</div>
              </Container>
            </ContentLayout>
          }
        />
        <Route
          path='/map'
          element={
            <MapWithMarkerPopup
              updateSplitPanelOpen={updateSplitPanelOpen}
              updateSplitPanel={updateSplitPanelFunction}
            />
          }
        />
        <Route
          path='/dashboard'
          element={<DashboardPage/>}
        />
        <Route
          path='*'
          element={
            // <Navigate to='/reports/top-five-usage' />
            // <TopFiveUsage />
            <DefaultPage
              updateSplitPanelOpen={updateSplitPanelOpen}
              updateSplitPanel={updateSplitPanelFunction}
            ></DefaultPage>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;
